<div class="p-4">
  <app-lookup-header/>

  <div class="tire-finder-bg flex items-center justify-center min-h-screen p-4 fade-slide-in relative">
    <div class="md:w-1/2 z-10 text-center">
      <app-card class="">
        <app-tabs class="space-y-4" [initialTab]="settings.get('default_search_tab').value">
          <app-tab title="Search by Vehicle" shortTitle="Vehicle" key="vehicle" id="lookup-tab-vehicle">
            <app-lookup-by-vehicle (search)="search($event)"></app-lookup-by-vehicle>
          </app-tab>

          <app-tab title="Search by Size" shortTitle="Size" key="size" id="lookup-tab-size">
            <ng-template>
              <app-lookup-by-size (search)="search($event)"></app-lookup-by-size>
            </ng-template>
          </app-tab>

          <app-tab title="Search by Manual" shortTitle="Manual" key="manual" id="lookup-tab-manual">
            <ng-template>
              <app-lookup-by-manual (search)="search($event)" [value]="manualSearch().value" [type]="manualSearch().type"/>
            </ng-template>
          </app-tab>
        </app-tabs>
      </app-card>
    </div>
  </div>

</div>
<app-release-notes-modal/>
